export const ADMIN_MEMBERS = 'members'
export const ADMIN_BILLING = 'billing'
export const ADMIN_BUDGETS = 'budgets'
export const ORDER_HISTORY = 'order-history'
export const DASHPASS = 'dashpass'
export const GROUPS = 'groups'
export const ADMIN_SUBPAGES = new Set([
  ADMIN_MEMBERS,
  ADMIN_BILLING,
  ADMIN_BUDGETS,
  ORDER_HISTORY,
  GROUPS,
  DASHPASS,
])
